import type { RootState } from '@/store';

import type { Conversa, Mensagem } from '../types/messaging.types';

export const selectConversas = (state: RootState) => state.messaging.conversas;
export const selectMensagensPorConversa = (state: RootState) =>
  state.messaging.mensagensPorConversa;
export const selectLoadingConversas = (state: RootState) => state.messaging.loadingConversas;
export const selectLoadingMensagens = (state: RootState) => state.messaging.loadingMensagens;
export const selectMessagingError = (state: RootState) => state.messaging.error;
export const selectLastEventAt = (state: RootState) => state.messaging.lastEventAt;
export const selectLastEventId = (state: RootState) => state.messaging.lastEventId;

export const selectConversaById = (conversaId: string) => (state: RootState) =>
  (state.messaging.conversas ?? []).find((c: Conversa) => c.id === conversaId) ?? null;

export const selectMensagensDaConversa = (conversaId: string) => (state: RootState) =>
  (state.messaging.mensagensPorConversa[conversaId] || []) as Mensagem[];

export const selectTotalMensagensDaConversa = (conversaId: string) => (state: RootState) =>
  state.messaging.totaisPorConversa[conversaId] ?? 0;

export const selectAttachmentUploadStatus = (state: RootState) => state.messaging.attachmentUpload;
